import LineChartReports from "./lineChart";
import { dateFormatterToMMDD } from "../../../utils/formatter";
import { useState } from "react";

const TrendReports = ({ reportTrendData, selectedType, refreshDate }: any) => {
  const [lastMonth, setLastMonth] = useState<any>(null);
  const monthMapping: { [key: string]: string } = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };
  let trendData = reportTrendData;
  if (selectedType === "Weekly") {
    trendData.salesLbs = [
      ...trendData?.salesLbs?.map((item: any) => {
        item["month"] = dateFormatterToMMDD(item["month"]);
        return item;
      }),
    ];
    trendData.salesDollars = [
      ...trendData?.salesDollars?.map((item: any) => {
        item["month"] = dateFormatterToMMDD(item["month"]);
        return item;
      }),
    ];
    trendData.transactionMarginDollar = [
      ...trendData?.transactionMarginDollar?.map((item: any) => {
        item["month"] = dateFormatterToMMDD(item["month"]);
        return item;
      }),
    ];
    trendData.transactionMargin = [
      ...trendData?.transactionMargin?.map((item: any) => {
        item["month"] = dateFormatterToMMDD(item["month"]);
        return item;
      }),
    ];
    trendData.years = trendData.year;
  }
  return (
    <div className="h-full w-full flex flex-col">
      <div className="grid grid-cols-2 grid-rows-2 gap-4 h-[95%] w-full p-[1vh]">
        <LineChartReports
          years={trendData?.years}
          data={trendData?.salesLbs}
          name={`${
            selectedType === "Cumulative" ? "Cumulative " : ""
          }Sales lbs.`}
          decimal={0}
          unit={""}
          selectedType={selectedType}
          lastMonth={lastMonth}
          setLastMonth={setLastMonth}
        />
        <LineChartReports
          years={trendData?.years}
          data={trendData?.salesDollars}
          name={`${
            selectedType === "Cumulative" ? "Cumulative " : ""
          }Sales ($)`}
          decimal={0}
          unit={""}
          selectedType={selectedType}
          lastMonth={lastMonth}
          setLastMonth={setLastMonth}
        />
        <LineChartReports
          years={trendData?.years}
          data={trendData?.transactionMargin}
          name={`${
            selectedType === "Cumulative" ? "Cumulative " : ""
          }Transaction Margin (%)`}
          decimal={2}
          unit={"%"}
          selectedType={selectedType}
          lastMonth={lastMonth}
          setLastMonth={setLastMonth}
        />
        <LineChartReports
          years={trendData?.years}
          data={trendData?.transactionMarginDollar}
          name={`${
            selectedType === "Cumulative" ? "Cumulative " : ""
          }Transaction Margin ($)`}
          decimal={0}
          unit={""}
          selectedType={selectedType}
          lastMonth={lastMonth}
          setLastMonth={setLastMonth}
        />
      </div>
      {trendData &&
        selectedType !== "Weekly" &&
        trendData?.years?.length === 2 && (
          <div className="h-[5%] flex justify-start items-center px-[1vh] text-[1.6vh] text-[#858585]">
            <div className="font-bold pr-1">Note :</div>
            <div>Stock only. Current month data (indicated by </div>
            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
              {/* <polygon
                points="10,6 14,14 6,14"
                fill="#213396"
                stroke="#213396"
                stroke-width="1"
              /> */}
              <circle
                cx="10"
                cy="10"
                r={2.2}
                fill="none"
                stroke={"#213396"}
                strokeWidth="2"
              />
            </svg>
            <div>
              ) is month-to-date and not directly comparable to previous year
            </div>
            {/* <div>{`${monthMapping[lastMonth]} ${trendData?.years[1]} data (marked with a `}</div>

            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
              <polygon
                points="10,6 14,14 6,14"
                fill="#E15759"
                stroke="#E15759"
                stroke-width="1"
              />
            </svg>

            <div>
              {`) is month-to-date as of ${refreshDate} and not directly comparable to the full month of ${monthMapping[lastMonth]} ${trendData?.years[0]}.`}
            </div> */}
          </div>
        )}
    </div>
  );
};

export default TrendReports;
